import React from 'react';
import useFlatRequestsCount from '../../../../../../hooks/useFlatRequestsCount';
import CountView from '../CountView/CountView';

const FlatCountRequestView = ({ requests = [] }) => {
  const values = useFlatRequestsCount(requests);

  return (
    <CountView
      values={values}
      isSquare={true}
    />
  );
};

export default FlatCountRequestView;
